function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UsaTemplate = require('./usa.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');

// Conditions follow Paths of Glory rule 16.3 (US Entry).
var STEPS = [{
  name: 'U.S. Neutral',
  note: '',
  next: 'Combined War Status reaches 30. The marker then moves to Zimmermann Telegram Allowed, and that event may be played.',
  stop: 'Keep Combined War Status below 30.'
}, {
  name: 'Zimmermann Telegram Allowed',
  note: 'War Status 30+',
  next: 'The Allies play Zimmermann Telegram as an event. The marker moves to Zimmermann Telegram. The United States becomes an active Allied nation, but US Reinforcement cards still may not be played.',
  stop: 'Keep the Allies from playing Zimmermann Telegram. Once Combined War Status has reached 30, the marker does not move back.'
}, {
  name: 'Zimmermann Telegram',
  note: '',
  next: 'On the turn after Zimmermann Telegram, the Allies play Over There. The marker moves to Over There, and US Reinforcement cards may be played, no more than one per turn.',
  stop: 'This step does not retreat. Over There cannot be played on the same turn as Zimmermann Telegram.'
}, {
  name: 'Over There!',
  note: '',
  next: 'The track is complete. The United States is fully in the war. The Allies may play US Reinforcement cards, but not more than one per turn.',
  stop: 'Nothing sends the marker back. The United States has entered the war.'
}];
var EMPHASIS = ['Zimmermann Telegram', 'Over There', 'Combined War Status', 'US Reinforcement', 'below 30', 'reaches 30'];
function emphasize(text) {
  var html = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  var terms = EMPHASIS.slice().sort(function (a, b) {
    return b.length - a.length;
  });
  for (var i = 0; i < terms.length; i++) {
    html = html.split(terms[i]).join('<strong>' + terms[i] + '</strong>');
  }
  return html;
}
var UsaOverlay = /*#__PURE__*/function () {
  function UsaOverlay(app, mod) {
    _classCallCheck(this, UsaOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.current = 1;
  }
  return _createClass(UsaOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "currentPosition",
    value: function currentPosition() {
      var position = 1;
      try {
        position = parseInt(this.mod.game.state.us_commitment_track, 10);
      } catch (err) {
        position = 1;
      }
      if (position < 1 || position > STEPS.length) {
        position = 1;
      }
      return position;
    }
  }, {
    key: "render",
    value: function render() {
      this.current = this.currentPosition();
      this.overlay.show(UsaTemplate());
      this.pushHudUnderOverlay();
      this.buildTrack();
      this.showStep(this.current);
      this.attachEvents();
    }
  }, {
    key: "buildTrack",
    value: function buildTrack() {
      var track = document.querySelector('.usa-overlay .paths-track-grid');
      if (!track) {
        return;
      }
      var html = '';
      for (var i = 0; i < STEPS.length; i++) {
        var step = i + 1;
        var note = STEPS[i].note ? "<span class=\"paths-stage-note\">".concat(STEPS[i].note, "</span>") : '';
        var index = String(step).padStart(2, '0');
        html += "\n        <button type=\"button\" class=\"paths-stage\" data-step=\"".concat(step, "\">\n          <span class=\"paths-stage-index\">").concat(index, "</span>\n          <span class=\"paths-stage-name\">").concat(STEPS[i].name, "</span>\n          ").concat(note, "\n          <span class=\"paths-stage-badge\">Current</span>\n        </button>\n      ");
      }
      track.innerHTML = html;
      var current = track.querySelector(".paths-stage[data-step=\"".concat(this.current, "\"]"));
      if (current) {
        current.classList.add('is-current');
        current.setAttribute('aria-current', 'true');
      }
    }
  }, {
    key: "showStep",
    value: function showStep(step) {
      var index = parseInt(step, 10);
      if (index < 1 || index > STEPS.length) {
        index = this.current;
      }
      var entry = STEPS[index - 1];
      var root = document.querySelector('.usa-overlay');
      if (!root || !entry) {
        return;
      }
      root.querySelectorAll('.paths-stage').forEach(function (el) {
        el.classList.toggle('is-focus', parseInt(el.dataset.step, 10) === index);
      });
      root.querySelector('.paths-track-focus').textContent = entry.name;
      root.querySelector('.paths-track-next').innerHTML = emphasize(entry.next);
      root.querySelector('.paths-track-stop').innerHTML = emphasize(entry.stop);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector('.usa-overlay');
      if (!root) {
        return;
      }
      root.querySelectorAll('.paths-stage').forEach(function (el) {
        el.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse') {
            _this.showStep(el.dataset.step);
          }
        });
        el.addEventListener('focus', function () {
          _this.showStep(el.dataset.step);
        });
        el.addEventListener('click', function (e) {
          e.preventDefault();
          _this.showStep(el.dataset.step);
        });
      });
      var board = root.querySelector('.paths-track-board');
      if (board) {
        board.addEventListener('pointerleave', function (e) {
          if (!e.pointerType || e.pointerType === 'mouse') {
            _this.showStep(_this.current);
          }
        });
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }]);
}();
module.exports = UsaOverlay;